import { I as l } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as n, createElementVNode as a } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconAirtable",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(l).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ a("path", {
  d: "M10.927 4.211 3.473 7.295a.5.5 0 0 0 .007.926l7.484 2.967c.658.261 1.39.261 2.048 0l7.484-2.968a.5.5 0 0 0 .007-.925L13.05 4.211a2.777 2.777 0 0 0-2.123 0",
  fill: "#FFBF00"
}, null, -1), h = /* @__PURE__ */ a("path", {
  d: "M12.652 12.81v7.413a.5.5 0 0 0 .684.465l8.34-3.237a.5.5 0 0 0 .315-.465V9.572a.5.5 0 0 0-.684-.464l-8.34 3.237a.5.5 0 0 0-.315.464",
  fill: "#26B5F8"
}, null, -1), u = /* @__PURE__ */ a("path", {
  d: "M10.705 13.192 8.23 14.387l-.251.121-5.225 2.504c-.331.16-.754-.082-.754-.45V9.603c0-.133.068-.248.16-.335a.568.568 0 0 1 .126-.094.532.532 0 0 1 .455-.035l7.922 3.139c.403.16.435.724.042.914",
  fill: "#ED3049"
}, null, -1), f = /* @__PURE__ */ a("path", {
  d: "M10.705 13.192 8.23 14.387 2.16 9.269a.567.567 0 0 1 .126-.095.532.532 0 0 1 .455-.035l7.922 3.139c.403.16.435.724.042.914",
  fill: "currentColor",
  "fill-opacity": ".25"
}, null, -1), m = [
  _,
  h,
  u,
  f
];
function p(t, b, i, g, v, e) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--airtable"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Airtable",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const x = /* @__PURE__ */ o(s, [["render", p]]);
export {
  x as default
};
//# sourceMappingURL=airtable.js.map
